import { Outlet } from "react-router-dom"
import { FundsProvider } from "./FundsContext";

export const Layout = () => {
    return (
        <FundsProvider>
            <Outlet />
        </FundsProvider>
    );
}